import React from 'react';
import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle, DialogTrigger } from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Textarea } from '@/components/ui/textarea';
import { Edit } from 'lucide-react';

interface EditTeamDialogProps {
    open: boolean;
    onOpenChange: (open: boolean) => void;
    teamName: string;
    setTeamName: (v: string) => void;
    teamDescription: string;
    setTeamDescription: (v: string) => void;
    updatingTeam: boolean;
    onUpdate: () => void;
}

export const EditTeamDialog: React.FC<EditTeamDialogProps> = ({
    open,
    onOpenChange,
    teamName,
    setTeamName,
    teamDescription,
    setTeamDescription,
    updatingTeam,
    onUpdate,
}) => {
    return (
        <Dialog open={open} onOpenChange={onOpenChange}>
            <DialogTrigger asChild>
                <Button variant="outline">
                    <Edit />
                    Edit Team
                </Button>
            </DialogTrigger>
            <DialogContent className="sm:max-w-[425px]">
                <DialogHeader>
                    <DialogTitle>Edit Team</DialogTitle>
                    <DialogDescription>
                        Update your team's name and description.
                    </DialogDescription>
                </DialogHeader>
                <div className="space-y-6 py-4">
                    <div className="space-y-2">
                        <Label htmlFor="edit-team-name">Team Name</Label>
                        <Input
                            id="edit-team-name"
                            value={teamName}
                            onChange={(e) => setTeamName(e.target.value)}
                            placeholder="Enter team name"
                            className="mt-1"
                        />
                    </div>
                    <div className="space-y-2">
                        <Label htmlFor="edit-team-description">Description</Label>
                        <Textarea
                            id="edit-team-description"
                            value={teamDescription}
                            onChange={(e) => setTeamDescription(e.target.value)}
                            placeholder="Enter team description"
                            rows={3}
                            className="mt-1 resize-none"
                        />
                    </div>
                </div>
                <DialogFooter>
                    <Button variant="outline" onClick={() => onOpenChange(false)}>
                        Cancel
                    </Button>
                    <Button onClick={onUpdate} disabled={updatingTeam}>
                        {updatingTeam ? 'Updating...' : 'Update Team'}
                    </Button>
                </DialogFooter>
            </DialogContent>
        </Dialog>
    );
};

export default EditTeamDialog;
